import React from "react";
import styled from "styled-components";
import { colors } from "../../../../styles/style";
import {
  FlexRowBetweenCenter,
  MediumIcon,
  SmallTextConstant,
} from "../../../shared/SharedStyles";
import goBackIcon from "../../../../images/goBackIcon.svg";
import { MilestoneClickerScriptText } from "../../common/SharedComponents";
import {
  calculateAgeInMonthsAt,
  formatAgeInMonths,
} from "../../../../common/helpers";

export const firstWordErrorMessages = {
  duplicate: "This word is already in the list",
  generic: "Something went wrong. Please try again.",
};

export const HTTP_STATUS_NOT_FOUND = 404;
export const HTTP_STATUS_CONFLICT = 409;

export const formatSoundedLike = (soundedLike: string) =>
  `It sounded like “${soundedLike}”`;

// dateOfBirth is milliseconds, saidOn is unix seconds.
export const formatAgeOldAt = (dateOfBirth: number, saidOn: number) =>
  `${formatAgeInMonths(
    calculateAgeInMonthsAt(dateOfBirth, saidOn * 1000)
  )} old`;

interface SparkleIconProps {
  size?: number;
}

export const SparkleIcon: React.FC<SparkleIconProps> = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M7 0.5L8.4 5.6L13.5 7L8.4 8.4L7 13.5L5.6 8.4L0.5 7L5.6 5.6Z"
      fill={colors.softBrown}
    />
  </svg>
);

interface FirstWordSheetHeaderProps {
  title: string;
  onClose: () => void;
}

export const FirstWordSheetHeader: React.FC<FirstWordSheetHeaderProps> = ({
  title,
  onClose,
}) => (
  <SheetHeaderContainer>
    <MediumIcon src={goBackIcon} alt="Back" onClick={onClose} />
    <SheetTitle>{title}</SheetTitle>
    <CloseButton type="button" aria-label="Close" onClick={onClose}>
      <CloseIcon className="bi bi-x-lg" />
    </CloseButton>
  </SheetHeaderContainer>
);

export const FirstWordScriptText = styled(MilestoneClickerScriptText)`
  font-size: 64px;
  line-height: 76px;
  overflow-wrap: anywhere;
`;

export const SoundedLikeText = styled.p`
  color: ${colors.darkBrown};
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.24px;
  overflow-wrap: anywhere;
`;

export const SheetErrorText = styled.p`
  margin: 4px 0 12px;
  color: ${colors.softOrange};
  font-size: 14px;
  font-weight: 450;
  letter-spacing: -0.21px;
  text-align: center;
`;

const SheetHeaderContainer = styled.div`
  ${FlexRowBetweenCenter}
  padding: 16px;
  width: 100%;
`;

const SheetTitle = styled.div`
  margin: auto;
  color: ${colors.darkBrown};
  ${SmallTextConstant}
`;

const CloseButton = styled.button`
  width: 44px;
  height: 44px;
  margin: -12px -12px -12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  color: ${colors.darkBrown};
  cursor: pointer;
`;

const CloseIcon = styled.i`
  font-size: 20px;
`;
